import React, {useContext, useState} from 'react'
import {useHttp} from '../hooks/http.hook'
import {AuthContext} from '../context/AuthContext'
import {objectLang, setErrorWindow, setLocalStorageItem} from "../functions"
import {ModalWin} from "../elements/ModalWin"
import {LoaderClass} from "../elements/LoaderClass"
import {CheckingCollectionsClass} from "../elements/CheckingCollectionsClass"

export const CheckingCollectionsPage = () => {
    setLocalStorageItem('page', 'CheckingCollectionsPage')

    const auth = useContext(AuthContext)
    const {request, loading} = useHttp()
    let lang = objectLang().language
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})

    if (loading) {
        return <LoaderClass/>
    }

    setAllowed(true)

    if (!allowed) {
        setDataModal(setErrorWindow())
        return (
            <>
                {<ModalWin data={dataModal}/>}
            </>

        )
    }

    return (
        <>
            <CheckingCollectionsClass
                auth={auth}
                request={request}
                lang={lang}
            />
        </>
    )
}
